import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseTemplateGroupPolicy extends BasePolicy {
    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a course template group');
        }

        return user.hasGroupPermissionTo('create a course template group');
    }
}
